import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import EDEStatementsPage, { getDefaultPageUI } from "components/EDEStatements/pages/EDEStatementsPage";
import Classes from "model";
import { useEffect, useState } from "react";

/**
 * @name CaptureMabiEDEStatementsEnrollmentMyStatementsMySettingsOpen
 * @returns {React.Component}
 * @description A capture in the MABI23 "Statement Preferences (EDE)" capture group.
 */
export default function CaptureMabiEDEStatementsEnrollmentMyStatementsMySettingsOpen(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    .update([ "mobileMenu" ], { isActive: true })
    .submit();

    useEffect(() => {
        document.querySelector(`.mobile [data-point="edeStatementsMainNav_Account_Access"] a`).click()
    }, []);

    return <EDEStatementsPage ui={ ui }/>;
}